import { render, staticRenderFns } from "./DetailHeader.vue?vue&type=template&id=65d52d41&scoped=true&"
import script from "./DetailHeader.vue?vue&type=script&lang=js&"
export * from "./DetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./DetailHeader.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DetailHeader.vue?vue&type=style&index=1&id=65d52d41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d52d41",
  null
  
)

export default component.exports